<template>
  <div class="tw-relative">
    <label :for="props.labelFor" :class="classes" v-bind="$attrs">
      <slot></slot>
    </label>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
type Position = "top" | "border";
export interface FormLabelProps {
  labelFor: string;
  position?: Position;
}

const positions = {
  top: "tw-mb-1 tw-block tw-text-base tw-font-normal tw-text-primary-grey-700",
  border:
    "tw--top-3.5 tw-absolute tw-left-6 tw-z-10 tw-h-5 tw-bg-white tw-px-1 tw-text-primary-grey-400",
};

const props = withDefaults(defineProps<FormLabelProps>(), {
  position: "top",
});

const classes = computed(() => {
  return [positions[props.position]];
});
</script>

<style scoped></style>
